import { queriesPayers } from "@query";
import { selectorDefaultCurrency } from "../selectors/selectorDefaultCurrency";

/**
 * The account's default currency, falling back to USD.
 *
 * Reads v3 payer settings. The v1 source this used (`GET /payments/service` via
 * `useQueryPaymentsStatus`) cannot answer any more — `WSService` throws
 * `NotMigrated` instead of making a request — so every caller was silently
 * getting the USD fallback regardless of the account's actual currency.
 */
export function useDefaultCurrency() {
  const queryPayerSettings = queriesPayers.getCurrentPayerSettings.useQuery({});
  return selectorDefaultCurrency(queryPayerSettings.data);
}
